<template>
  <div class="activity-wrap">
    <app-header />
    <div class="wrap">
      <div class="mod mod1">
        <h2>迎春专业版增值礼包</h2>
        <div class="pdt-info">
          <div class="info-l">
            <div class="pdt-item pdt-item-nogap"><strong>《大智慧专业版》</strong><small>电脑版</small></div>
            <div class="pdt-item">大智慧移动端指标：<p class="ft-org">· 双突战法&nbsp;&nbsp;· 神奇D信号</p></div>
          </div>
          <div class="info-m">
            <div class="card">
              <span class="tag-lt">买1得3</span>
              <span class="tag-rb">元 / 年</span>
              <span class="tag-unit">优惠价</span>
              <strong>1998</strong>
            </div>
          </div>
          <div class="info-r">
            <span @click="goUrl(3042)" class="btn-buy">立即购买</span>
          </div>
        </div>
        <p class="tips">迎春专业版礼包内容：大智慧专业版电脑端一年，大智慧移动指标双突战法一年及神奇D信号一年，不可叠加。</p>
        <div class="risk">注意事项：本礼包产品中的移动指标将单独计算使用期限，已经购买过移动双突战法及神奇D信号的客户不可与本礼包中包含的双突战法及神奇D信号叠加使用。</div>
      </div>
      <div class="mod">
        <h2>策略智慧礼包</h2>
        <div class="pdt-info">
          <div class="info-l">
            <div class="pdt-item pdt-item-nogap"><strong>《大智慧策略投资终端》</strong><small>电脑版</small></div>
            <div class="pdt-item">优选大师财富版<small>大智慧移动端</small></div>
            <div class="pdt-item">大智慧APP指标<small>(18个)</small></div>
          </div>
          <div class="info-m">
            <div class="card">
              <span class="tag-lt">一口价</span>
              <span class="tag-rb">元 / 年</span>
              <span class="tag-unit">优惠价</span>
              <strong>56000</strong>
            </div>
          </div>
          <div class="info-r">
            <span @click="goUrl(3041)" class="btn-buy">立即购买</span>
          </div>
        </div>
        <p class="tips">策略智慧礼包内容：策略投资终端1年+优选大师财富版1年+移动18指标1年<br/>18个指标包含：云梯通道、双突战法、神奇D信号、九转交易、主力筹码追踪、黄金通道、波段王、白马智投、蓄势待发、追击反转、尾盘动能、资金搏击、题材王、异动查、情绪转点、机构热股、抢筹先锋、分时顶底</p>
        <div class="risk">注意事项：本礼包产品中的移动指标将单独计算使用期限，已经购买过移动18个相关同类型指标的客户不可与本礼包中包含的18个移动指标叠加使用。</div>
      </div>
      <!-- <div class="rules">
        活动日期：2022年1月1日-2月28日&nbsp;&nbsp;&nbsp;&nbsp;活动须知：《大智慧专业版》、《大智慧策略投资终端》、《优选大师财富版》的双年卡，季卡，月卡均不参与活动。
      </div> -->
      <div class="rules">
        活动须知：《大智慧专业版》、《大智慧策略投资终端》、《优选大师财富版》的双年卡，季卡，月卡均不参与活动。
      </div>
    </div>
    <div class="act-footer">入市有风险，投资需谨慎！</div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',

    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {
    
    
  },
  methods: {
    goUrl (key, month=12) {
      let routerDate;
      // if (this.token && key !== 4024) {
      //   routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key, month: month}})
      // } else {
      //   routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      // }
      routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      let {href} = routerDate
      window.open(href, "_blank")
    },
  }
}
</script>
<style lang="scss" scoped>
div, p, span, a{
  box-sizing: border-box;
}
.activity-wrap{
  background:#a62b32 url(../../assets/images/activity/activityTiger/bg.jpg) no-repeat center 100px;
  .wrap{
    width:1200px;margin:0 auto;
    .mod1{
      margin-top:403px;
    }
    .mod{
      border-radius:30px;border:4px solid #ec8a3d;padding-top:90px;position:relative;background:#cf3635;margin-bottom:60px;
      &:before{
        content:'';position:absolute;left:50%;top:-7px;background:url(../../assets/images/activity/activityTiger/bow.png) no-repeat center top;width:514px;height:78px;margin-left:-257px;
      }
      h2{
        font-size:30px;font-weight:bold;color:#ffdd96;text-align:center;background:url(../../assets/images/activity/activityTiger/title.jpg) no-repeat center top;margin-bottom:40px;
      }
      .pdt-info{
        overflow:hidden;padding:0 34px;color:#fff;
        .info-l{
          float:left;width:35%;
          .pdt-item{
            border:2px solid #f45453;border-radius:10px;padding:15px 20px;font-size:24px;margin-bottom:10px;
            .ft-org{
              color:#ffdd96;
            }
            p{
              margin-top:10px;
            }
            strong{
              font-size:30px;font-weight:normal;
            }
            small{
              font-size:14px;margin-left:10px;
            }
            &-nogap{
              padding:15px 0;
              small{
                margin:0;
              }
            }
          }
        }
        .info-m{
          float:left;width:40%;
          .card{
            background:url(../../assets/images/activity/activityTiger/card.jpg) no-repeat center top;width:355px;height:190px;margin:0 auto;font-size:24px;position:relative;text-align:center;
            strong{
              position:absolute;left:0;top:0;right:0;line-height:190px;font-size:72px;font-weight:normal;
            }
          }
          .tag-lt{
            position:absolute;left:20px;top:10px;
          }
          .tag-rb{
            position:absolute;right:20px;bottom:20px;
          }
          .tag-unit{
            position:absolute;font-size:18px;right:13px;top:18px;
          }
        }
        .info-r{
          float:left;width:25%;
        }
        .btn-buy{
          display:block;width:280px;height:90px;line-height:90px;font-size:44px;color:#fff;margin:50px auto 0;border-radius:50px;text-align:center;background-image:linear-gradient(to top,#db9c55 0%,#f6ce89 100%);box-shadow:0 8px 10px rgba(161,27,27,0.7);cursor:pointer;
        }
      }
      .tips{
        font-size:16px;color:#fff;opacity:0.7;margin:5px 350px 30px 54px;line-height:1.7;
      }
      .risk{
        background:#b82c2b;font-size:14px;color:#fca159;line-height:40px;padding:0 58px;border-radius:0 0 26px 26px;
      }
    }
    .rules{
      font-size:16px;color:#fff;opacity:0.5;text-align:center;
    }
  }
  .act-footer{
    background:#7f1016;text-align:center;font-size:24px;color:rgba($color: #fff, $alpha: 0.5);line-height:100px;margin-top:45px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activityTiger.vue